if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.baseUrl = window.levi9BaseUrl;
        this.productAttributeId = window.getProductId(); 
        this.printIds = window.prdProducts; 
      }


      async onSubmitHandler(evt) {
        evt.preventDefault();
        const errorMessageDiv = document.getElementById("atc-issue");
        const closeButton = document.querySelector(".atc-issue__close");
        if(closeButton) {             
          closeButton.addEventListener("click", function() {
              errorMessageDiv.classList.add("atc-issue-hidden");              
          });
        }

        const printTechnique = document.querySelector('.radio-btn:checked')?.value;

        // Get the selected color
        const colorPickerElement = document.querySelector('.colorEN:checked');
        const colorEN = colorPickerElement.dataset.configuratorcolor;
        // console.log('COLOR',  this.productAttributeId);
        const printPrice = window.getProductPrice() / Shopify.currency.rate;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // Fetch data before adding to cart
        const url = `${this.baseUrl}/ProductDesigns/product/${this.productAttributeId}/colour/${colorEN}`;
        let orderDesignId;

        const getDesign = async () => {
          try {
            const response = await fetch(url, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'x-token': localStorage.getItem('authToken'),
                'x-customerId': window.customerId || localStorage.getItem('usersIds'),
              },
            });
            const data = await response.json();
            orderDesignId = data;
          } catch (error) {
            console.error('Error fetching design:', error);
            // Handle the error as needed
            return;
          }
        };

        await getDesign();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // Add additional properties to formData
        formData.append('properties[_designName]', orderDesignId);
        formData.append('properties[_type]', 'configurator_product');
        formData.append('properties[_order_design_id]', orderDesignId);
        formData.append('properties[_configurator_design_id]', orderDesignId);
        formData.append('properties[_print_positions]', this.printIds.toString());
        formData.append('properties[_direct]', true);
        formData.append('properties[_print_price]', printPrice);
        formData.append('properties[_print_technique]', printTechnique);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;        
    
        
        
        if(orderDesignId != undefined) {
          
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
            errorMessageDiv.classList.remove("atc-issue-hidden");
            setTimeout(()=>{
              errorMessageDiv.classList.add("atc-issue-hidden");
            },4000)
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
        } else {           
          errorMessageDiv.classList.remove("atc-issue-hidden");
          setTimeout(()=>{
            errorMessageDiv.classList.add("atc-issue-hidden");
          },4000)

          this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) {
            this.submitButtonText.textContent = "";
            // console.log('1111',this.submitButtonText.textContent)
            this.submitButtonText.textContent = text;
          }        
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = "";
          // console.log('2222',this.submitButtonText.textContent)        
          this.submitButtonText.textContent = window.variantStrings.addToCart;
          // console.log('3333',this.submitButtonText.textContent)        
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}